import axios from 'axios'
import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { getXToken } from '../services/nativeBridge'
import { toast } from '../services/toastService'
import CryptoUtils from '../utils/utils'

// 基础配置
const BASE_URL = 'https://app.jixianxueyuan.com'

/**
 * 统一响应格式接口
 */
export interface ApiResponse<T = any> {
  status: number
  encryp: boolean
  content: T
  error?: string | { errorCode: number; errorInfo: string }
  parameters?: any
}

/**
 * 创建 Axios 实例
 */
const service: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * 请求拦截器
 */
service.interceptors.request.use((config: InternalAxiosRequestConfig) => {

    const method = config.method?.toUpperCase() || 'GET'

    // 1. 注入 Token
    const token = getXToken()
    if (!!token) {
      config.headers['x-Token'] = token
    } else {
      config.headers["authorization"] = `Basic dS1ndWVzdDozYmY0YmEwMy1iYWI2LTRhZDYtOWExNC00YzZhZDdhZjU4YzA=`
    }
    if (method === 'GET') {
      config.headers['content-type'] = "application/x-www-form-urlencoded; charset=utf-8"
    } else {
      config.headers['content-type'] = 'application/json'
    }
    
    // 2. 注入设备信息
    const targetInfo = `device:unknown,sysName:customApp,sysVer:1.0.0,appVer:1.0.0`
    if (config.method === 'get') {
      config.params = { ...config.params, targetInfo }
    } else if (config.data && typeof config.data === 'object') {
      config.data = { ...config.data, targetInfo }
      if (config.url && config.url.includes('/c/') && method === 'POST') {
        config.data = CryptoUtils.encryptAes(config.data)
      }
    }

    return config
  }, (error) => Promise.reject(error)
)

/**
 * 响应拦截器
 */
service.interceptors.response.use((response: AxiosResponse<ApiResponse>) => {
    const { data } = response
    
    console.log('service.interceptors.response.use >> ', data)
    // 1. 处理加密响应
    if (data.encryp && typeof data.content === 'string') {
      try {
        data.content = CryptoUtils.decryptAes(data.content)
      } catch (e) {
        console.error('[Network] Decryption Failed:', e)
      }
    }

    // 2. 统一成功/失败判断
    // 假设 status === 1 为成功，或者没有 status 字段且 HTTP 状态码为 2xx
    const isSuccess = data.status === 1 || (data.status === undefined && response.status >= 200 && response.status < 300)

    if (!isSuccess) {
      const errorMsg = typeof data.error === 'string' ? data.error : (data.error?.errorInfo || '请求失败')
      toast.error(errorMsg)
      return Promise.reject(new Error(errorMsg))
    }

    return response
  }, (error) => {
    let message = '网络请求失败'
    if (error.response) {
      const { status } = error.response
      message = `服务器错误(${status})`
    } else if (error.request) {
      message = '未收到服务器响应'
    } else {
      message = error.message
    }
    
    toast.error(message)
    return Promise.reject(error)
  }
)

export default service
